import {
  AxiosResponse,
  RequestInterceptor,
} from '@tencent/wphk-base-request';
import { consumeLoginToken } from '@tencent/wphk-act-base-api';

const consumeTokenState = {
  key: 'consume_login_token_flag',
  checkIsConsumed() {
    return sessionStorage.getItem(this.key) === '1';
  },
  setTokenConsumed() {
    sessionStorage.setItem(this.key, '1');
  },
};

/**
 * 用于消费掉用不到的登陆token，防止token被分享出去，造成安全隐患
 */
export default class ConsumeTokenIntercetor implements RequestInterceptor {
  errCode: string[] = [];
  constructor(errCode: string[]) {
    this.errCode = errCode;
  }
  handleResponse(response: AxiosResponse) {
    const retcode = response.data?.retcode;
    const isSessionOut = this.errCode.includes(retcode);
    const isConsumed = consumeTokenState.checkIsConsumed();
    if (!isSessionOut && !isConsumed) {
      try {
        consumeLoginToken();
      } catch (error) {
        console.log(`consume login token fail: ${(error as unknown as Error).message}`);
      }
      consumeTokenState.setTokenConsumed();
    }
    return response;
  }
}
